class MobileLegend {
    constructor() {
        document.querySelector('.pcsl-mobile-legend-toggle').addEventListener('click', () => {
            const legend = document.querySelector('.pcsl-mobile-legend');
            if (legend.classList.contains('open')) {
                this.close();
            } else {
                this.open();
            }
        });

        document.querySelector('.pcsl-mobile-legend-close').addEventListener('click', (event) => {
            event.stopPropagation();
            this.close();
        });
    }

    open() {
        document.querySelector('.pcsl-mobile-legend').classList.add('open');
    }

    close() {
        document.querySelector('.pcsl-mobile-legend').classList.remove('open');
    }
}
